// Angular
import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
// Model
import { FORM_EVENT, SCHEMA_TYPE, SCHEMA_PHOTO_PATH } from '../../../models/enums.model';
import { BroadcastService, BroadcastEventModel } from '@cv-invision/core';
// Service
import { ViewsService } from '../../../services/views.service';
import { ReplacePointerIndexFromOptionsPipe } from '../../../sections-review/components/pipes/tables.pipe';
// Other
import { JPathService } from '@cv-invision/cv.component-library.ux';
import { Lightbox } from 'ngx-lightbox';

@Component({
	selector: 'cv-invision-photo-group',
	templateUrl: './photo-group.component.html',
	styleUrls: ['./photo-group.component.scss'],
	providers: [ReplacePointerIndexFromOptionsPipe]
})
export class PhotoGroupComponent implements OnInit, OnChanges {
	@Input() section;
	@Input() index?;
	@Input() isEditing = false;

	get order(): any {
		return this.viewsService.order;
	}
	get photos(): any {
		return this.viewsService.photos;
	}
	get photosSelected(): any {
		return this.viewsService.photosSelected;
	}

	images = [];
	albums = [];

	constructor(
		private changeDetectorRef: ChangeDetectorRef,
		private broadcastService: BroadcastService,
		private viewsService: ViewsService,
		private lightbox: Lightbox,
		public replacePointerIndexFromOptionsPipe: ReplacePointerIndexFromOptionsPipe,
		private jPathService: JPathService
	) {
		//
	}

	/**
	 * Init
	 */
	ngOnInit(): void {
		this.loadImages();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (
			('section' in changes && !changes.section.firstChange)
			|| ('index' in changes && !changes.index.firstChange)
		) {
			this.loadImages();
		}
	}

	/**
	 * initialize the image variable with the images for certain section.
	 * ToDo:
	 * - Put 1004 ready
	 */
	async loadImages(): Promise<void> {
		this.images = [];
		this.albums = [];

		let pattern = '';
		switch (this.order.schema) {
			case SCHEMA_TYPE.CVDS_32:
				pattern = `${this.section}s-${this.index}`;
				break;

			case SCHEMA_TYPE.CVDS_33:
				pattern = this.index;
				break;
		}

		const path = this.transform(SCHEMA_PHOTO_PATH[this.order.schema], pattern);
		const photoPath = `@.refJsonPath=='${path}'`;
		const images = this.jPathService.getQuery(this.photos, `$..[?(${photoPath})]`);

		setTimeout(() => {
			this.images = [...images];
			images.forEach(img => {
				const album = {
					src: img.path,
					caption: '',
					thumb: ''
				};
				this.albums.push(album);
			});
			// Ensure the images are loaded every time
			this.changeDetectorRef.markForCheck();
		});
	}

	/**
	 * update main photo and send the broadcast event
	 * @param event
	 */
	setMainPhoto(event: any): void {
		const photo = event.photo;
		this.photos.map(p => {
			if (p.refJsonPath === photo.refJsonPath) {
				if (p.id === photo.id) {
					p.metadata.isPrimary = !p.metadata.isPrimary;
				} else {
					p.metadata.isPrimary = false;
				}
			}
		});

		this.broadcastService.broadcast({
			name: FORM_EVENT.PHOTO_PRIMARY,
			event: {
				data: JSON.parse(JSON.stringify(this.photos))
			}
		});
	}

	/**
	 * set or remove from the selected photos array
	 * @param event
	 */
	selectedPhoto(event: any): void {
		const index = this.photosSelected.indexOf(event.photo.id);
		if (index > -1) {
			this.photosSelected.splice(index, 1);
		} else {
			this.photosSelected.push(event.photo.id);
		}
		this.broadcastService.broadcast({
			name: FORM_EVENT.PHOTO_SELECT,
			event: {
				data: this.photosSelected
			}
		});
	}

	/**
	 * Open lightbox
	 * @param index
	 */
	openGallery(data: any): void {
		const photoIndex = this.images.indexOf(data.photo);

		if (photoIndex > -1) {
			this.lightbox.open(this.albums, photoIndex);
		}
	}

	/**
	 * Replace the {index} params in the path for the ones in the array
	 * @param path
	 * @param indexs
	 */
	private transform(path: string, indexs: string): string {
		const indexArray = (indexs + '').split('-');
		const pattern = /\{index\}/gm;
		const testPath = path;

		let i = 0;
		const nPath = testPath.replace(pattern, function (s: any, key: string | number): any {
			const replace = indexArray[i];
			i++;
			return replace || s;
		});

		return nPath;
	}
}
